<template>
  <v-layout justify-center>
    <v-layout
      v-if="loading"
      justify-center
      align-center
      style="height: 100vh; width: 100vw"
    >
      <v-progress-circular indeterminate color="blue"></v-progress-circular>
    </v-layout>
    <div v-else class="mt-8">
      <div class="font-weight-bold text-center mb-4" style="font-size: larger">
        契約・概要書面表示
      </div>
      <v-container
        style="
          max-height: 65vh;
          overflow-y: auto;
          width: 100%;
          min-height: 65vh;
        "
      >
        <div v-for="(canvasId, index) in canvases" :key="index">
          <canvas :ref="canvasId" :id="canvasId"></canvas>
        </div>
      </v-container>
      <v-container class="d-flex flex-column align-center justify-center">
        <v-checkbox
          v-model="acceptContractRule"
          label="上記内容を確認しました。"
          class="ps-5"
        />
        <v-btn
          class="info"
          :disabled="!acceptContractRule"
          @click="navigateToContractInput"
        >
          次へすすむ
        </v-btn>
      </v-container>
    </div>
  </v-layout>
</template>

<script>
export default {
  name: "ImportantRule",
  title: "契約・概要書面表示",
  data: () => ({
    acceptContractRule: false,
    userId: null,
    pdfBytes: null,
    canvases: [],
    loading: true,
  }),
  created() {
    this.userId = this.$route.params.userId;
    this.courseId = this.$route.params.courseId;
    this.getInitialData();
  },
  methods: {
    async getInitialData() {
      const pdfData = await this.getPdfData(
        `/api/v1/course-contract/course-rules/${this.courseId}`
      );
      this.pdfBytes = pdfData;
      await this.renderPdf();
    },

    async getPdfData(url) {
      try {
        const response = await this.$axios.get(url, {
          responseType: "arraybuffer",
        });
        return response.data;
      } catch (error) {
        console.error(`Error fetching PDF from ${url}:`, error);
        throw error;
      }
    },

    async renderPdf() {
      if (!this.pdfBytes) return;

      const pdfjsLib = window["pdfjs-dist/build/pdf"];
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js";

      try {
        const pdf = await pdfjsLib.getDocument({ data: this.pdfBytes }).promise;
        this.loading = false;

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);

          const viewport = page.getViewport({ scale: 2.5 });
          const canvasId = `pdfCanvas_${pageNum}`;
          this.canvases.push(canvasId);

          this.$nextTick(async () => {
            const canvas = this.$refs[canvasId][0];
            canvas.height = viewport.height;
            canvas.width = viewport.width;

            const context = canvas.getContext("2d");
            const renderContext = {
              canvasContext: context,
              viewport: viewport,
            };

            await page.render(renderContext).promise;
          });
        }

      } catch (error) {
        console.error("Error rendering PDF:", error);
      }
    },

    navigateToContractInput() {
      this.$store.dispatch("updateContractTempData", {});
      this.$router.push({
        name: "customer_contract_input",
        params: {
          userId: this.userId,
          courseId: this.courseId,
        },
      });
    },
  },
};
</script>

<style scoped>
canvas {
  margin-bottom: 20px;
  width: 100%;
}
</style>
